<template>
  <div class="pff container" v-if="customFields.fifty_fifty_images">
    <div :key="index" v-for="index in (customFields.fifty_fifty_images || '').split(',')">
      <img class="pff__image" :src="imageSize(imageSet[index].image, assetSize)" alt="">
    </div>
  </div>
</template>

<script>
import { imageSize } from '@/scripts/helpers/util'

export default {
  name: 'ProductFiftyFifty',
  props: {
    customFields: Object
  },
  methods: {
    imageSize
  },
  computed: {
    assetSize () {
      return (this.$mq === 'mobile') ? 'x600' : (this.$mq === 'tablet') ? 'x800' : 'x1000';
    },
    imageSet (index) {
      if (!this.customFields.fifty_fifty_images) return []
      const images = (this.customFields.fifty_fifty_image || '').split('|###|')

      return this.customFields.fifty_fifty_images
        .split(',')
        .map(index => ({
          image: images[index],
        }))
    }
  }
}
</script>

<style lang="scss" scoped>
.pff {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: $container-max-width;
  padding: 60px 15px 80px 15px;
  @include mobile-only {
    padding: 30px 15px;
  }
  > div {
    &:nth-child(2) {
      margin-left: 35px;
      @include mobile-only {
        margin-left: 10px;
      }
    }
    img {
      max-width: 100%;
    }
  }
}
</style>
